import Vue from 'vue'
import VueRouter from 'vue-router'
import EventBus from '../service/EventBus'
import { store } from '../store/store'
import routes from './routes.js'
import SharedAuthService from '../service/SharedAuthService'
import AuthBootstrapService from '../service/AuthBootstrapService'

Vue.use(VueRouter)

const router = new VueRouter({
    base: window.MyConfig.pathDefault,
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0, left: 0 }
      }
    },
    routes: routes
})



//check route
router.beforeEach(async function(to, from, next) {
  if ((to.name && to.name == 'Admin-Timekeeping-TimekeepingConfig-AgentConnection') || (from.name && to.name == 'Admin-Timekeeping-TimekeepingConfig-AgentConnection') ) {
    if (to.query.t) {
      store.commit('redirectLogin', 'Admin-Timekeeping-TimekeepingConfig-AgentConnection')
    }
  }
  if (window.reloadListDocument) {
    clearTimeout(window.reloadListDocument)
  }
    if (window.setTimeoutX) {
      clearTimeout(window.setTimeoutX)
    }
    if (window.setTimeoutY) {
      clearTimeout(window.setTimeoutY)
    }
    if (window.setTimeoutZ) {
      clearTimeout(window.setTimeoutZ)
    }
    if (window.setTimeoutEmployee) {
      clearTimeout(window.setTimeoutEmployee)
    }
    SharedAuthService.hydrateLocalTokenFromSharedCookie()
    let getToken = SharedAuthService.getLocalToken()
    let urlCreateDocumentDrafting = ['Admin-DocumentDrafting-create', 'Admin-DocumentDrafting-create-drafting']
    if (from.name != to.name) {
      if (!urlCreateDocumentDrafting.includes(to.name)) {
        //Thực hiện xóa LocalStorage dataDraftingCreate khi chuyển trang không phải là tạo mới
        localStorage.removeItem('dataForm')
      }
      if (to.meta.page && to.meta.page == 'admin') {
        if (!getToken) {
          next({
            name: 'Auth-Login',
            query: {
              redirect: to.fullPath
            }
          })
          return
        }
        try {
          await AuthBootstrapService.ensureBootstrapped()
          if (
            AuthBootstrapService.canAccessRoute(to) ||
            AuthBootstrapService.hasBootstrapContextWarnings()
          ) {
            if (
              from.meta.collection != to.meta.collection
            ) {
              if (sessionStorage.getItem('filterDoc') && to.meta.collection != 'Document') {
                sessionStorage.removeItem('filterDoc')
              }
              EventBus.$emit('ChangeRouteDefault')
            }
            EventBus.$emit('ChangeRoute')
            EventBus.$emit('ChangeRouteSubNav')
            EventBus.$emit('ChangeRouteCheckHideInformation')
            if (AuthBootstrapService.hasBootstrapContextWarnings()) {
              console.warn('Auth bootstrap finished with partial context, keeping current session active')
            }
            next()
          } else {
            window.toastr.options.timeOut = 7000
            toastr.warning('Không có quyền truy cập trang này')
            setTimeout(() => {
              window.toastr.options.timeOut = 3500
              next(SharedAuthService.getDefaultRouter())
            }, 500)
          }
        } catch (error) {
          console.log('error index', error)
          if (AuthBootstrapService.isAuthFailure(error)) {
            SharedAuthService.clearSharedAuth()
            window.localStorage.clear()
            next({
              name: 'Auth-Login',
              query: {
                redirect: to.fullPath
              }
            })
            return
          }

          toastr.warning('Dữ liệu người dùng đang tải chậm, hệ thống giữ nguyên phiên làm việc để thử lại')
          next()
        }
      } else if (to.meta.page && to.meta.page != 'admin') {
        if (getToken && to.name == 'Auth-Login') {
          next(SharedAuthService.resolveRedirectPath(to.query.redirect))
        } else {
          next()
        }
      } else {
        window.localStorage.clear()
        next('/auth/login')
      }
    } else if (from.name && to.name && (from.name == to.name)) {
      next()
    } else {
      if (!to.name && !store.state.currentUser) {
        SharedAuthService.clearSharedAuth()
        window.localStorage.clear()
        next('/auth/login')
      } else {
        next(SharedAuthService.getDefaultRouter())
      }
    }
})

export default router
